import * as types from './types';

export default {
  /* eslint-disable no-param-reassign */
  [types.BREADCRUMB_SLICE](state, params) {
    state.navigation.asidePath = state.navigation.asidePath.slice(params.start, params.end);
  },

  [types.BREADCRUMB_UPDATE_CURRENT_GROUP](state, object) {
    state.navigation.currentGroup = object;
  },

  [types.BREADCRUMB_PUSH](state, object) {
    state.navigation.asidePath.push(object);
  },

  [types.UPDATE_ASIDE_ELMTS](state, array) {
    state.navigation.asideElmts = array;
  },

  [types.SET_BREADCRUMBS](state, array) {
    state.navigation.asidePath = array;
  },

  [types.UPDATE_VIEW_CARD](state, boolean) {
    state.layout.isViewCardActive = boolean;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/chorus/mutations.js